import "../analyticsresults/AnalyticsResults.css";
import ActionInput from "../../../components/common/actioninput/ActionInputField";
import ButtonComponent from "../../../components/common/button/Button";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TopSection from "../TopSection";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { toast } from "react-toastify";
import { getViewAllDetailsEndpoint, } from "../../../common/endpoints";
import { useDispatch, useSelector } from "react-redux";
import { getViewAllDetails } from "../../../redux/actions/ViewAllLineItemsDataSlice";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { getPowerBIMaterialDetailsData } from "../../../redux/actions/LTPlanner/PowerBIMaterialDetailsSlice";
import { Loader } from "../../../components/common/Loader";
import LeadtimeModel from "../analyticsresults/LeadTimeModal";

const DPSPlannerAnalyticsResultsDetails = (props) => {
  const dispatch = useDispatch();
  const stateSelector = useSelector((state) => state);
  const navigate = useNavigate();
  const location = useLocation();
  const combinedObject = location?.state?.combinedObject || {};
  const [openViewAllModal, setOpenViewAllModal] = useState(false);
  const [viewAllData, setViewAllData] = useState({});
  const [powerBIAccessToken, setPowerBIAccessToken] = useState("");
  const [powerBIEmbedURL, setPowerBIEmbedURL] = useState("");
  const [powerBIReportID, setPowerBIReportID] = useState("");
  const [confidenceLevel, setConfidenceLevel] = useState(combinedObject?.data?.recomConfidenceLevel);
  const [formData, setFormData] = useState({
    LTData: combinedObject?.data?.finalLt,
    potentialImpact: combinedObject?.data?.potentialImpact
  });

  const getViewAllData = async () => {
    try {
      const responseViewAllDetails = await dispatch(getViewAllDetails({
        dynamicEndpoint: `${getViewAllDetailsEndpoint}/${combinedObject?.data?.runSeqId}`,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseViewAllDetails?.meta?.requestStatus === 'fulfilled') {
        setViewAllData(responseViewAllDetails?.payload)
      } else {
        console.error('Failed to fetch data:', responseViewAllDetails?.payload?.errorMessage);
        setViewAllData({})
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }
  const handleOpenViewAllModal = (row) => {
    setOpenViewAllModal(true);
    getViewAllData(row);
  }
  const handleCloseViewAllModal = () => {
    setOpenViewAllModal(false);
    setViewAllData({})
  }
  const group_id = process.env.REACT_APP_PBI_DEMONSTRATED_LT_GROUP_ID
  const report_id = process.env.REACT_APP_PBI_DEMONSTRATED_LT_REPORT_ID;

  const filter = [
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "material_poitem",
      },
      operator: "Equals",
      values: [combinedObject?.data?.materialId],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "supplier",
      },
      operator: "Equals",
      values: [combinedObject?.data?.supplierId],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "plant_poitem",
      },
      operator: "Equals",
      values: [combinedObject?.data?.plant],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "LTA_JOB_RUN_ID",
      },
      operator: "Equals",
      values: [combinedObject?.data?.runSeqId],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "purchasingdocumenttype",
      },
      operator: "Equals",
      values: [combinedObject?.data?.purchDocType],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    },
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "Month",
        column: "PREDOMINANT_TRANSPORT_NAME",
      },
      operator: "Equals",
      values: [combinedObject?.data?.transportMode],
      filterType: models.FilterType.Basic,
      requireSingleSelection: true
    }
  ];

  const incotermFilter = {
    $schema: "http://powerbi.com/product/schema#basic",
    target: {
      table: "Month",
      column: "INCOTERSLOCATION1_POITEM",
    },
    operator: "Equals",
    values: [combinedObject?.data?.incotermLocation],
    filterType: models.FilterType.Basic,
    requireSingleSelection: true
  };

  const embedConfig = {
    type: 'report',
    id: powerBIReportID,
    embedUrl: `${powerBIEmbedURL}`,
    accessToken: powerBIAccessToken,
    tokenType: models.TokenType.Embed,
    settings: {
      panes: {
        filters: {
          expanded: false,
          visible: false,
        },
      },
      navContentPaneEnabled: false,
      layoutType: models.LayoutType.Custom,
      customLayout: {
        displayOption: models.DisplayOption.FitToWidth,
      },
    },
    filters: combinedObject?.data?.purchDocType === "YIC" ? filter : combinedObject?.data?.purchDocType === "YIP" ? filter : [...filter, incotermFilter]
  }

  useEffect(() => {
    const getPowerBIDetails = async () => {
      try {
        const responsePowerBIDetails = await dispatch(getPowerBIMaterialDetailsData({
          dynamicEndpoint: `api/powerBI/embedDetails/group/${group_id}/report/${report_id}`,
          params: {
            plant: localStorage.getItem("selectedLTPlantCode")
          }
        }));
        if (responsePowerBIDetails?.meta?.requestStatus === 'fulfilled') {
          setPowerBIEmbedURL(responsePowerBIDetails?.payload?.embedUrl);
          setPowerBIReportID(responsePowerBIDetails?.payload?.reportId);
          setPowerBIAccessToken(responsePowerBIDetails?.payload?.accessToken)
        } else {
          toast.error(responsePowerBIDetails?.payload?.errorMessage, {
            autoClose: 2000,
          });
        }
      } catch (error) {
        console.error('API error:', error);
      }
    }
    getPowerBIDetails();

  }, []);
  return (
    <div>
      <TopSection
        tabTitle="DPS Analytics Results"
        labelList={[
          { title: "Home", path: "/landing-page" },
          { title: "DPS Analytics Results", path: "/DPS-Planner-analytics" },
          { title: "Results" },
        ]}
      />
      <div className="analytic-results-tab">
        <div className="analytic-results-top-section">

          <div className="result-item">
            <span className="analytics-text">
              Period Consider for Analytics
            </span>
            <p>{combinedObject?.data?.periodConsidered || "-"}</p>
          </div>
          <div className="result-item">
            <span className="analytics-text">Analytics Initiated by</span>
            <p>{combinedObject?.data?.ltInitiatedBy || "-"}</p>
          </div>
          <div className="result-item">
            <span className="analytics-text">Analytics Run Unique ID</span>
            <p>{combinedObject?.data?.runOutputSeqId || "-"}</p>
          </div>
        </div>
        <div className="input-details">
          <p >
            <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={handleOpenViewAllModal}>Click Here</span>
            &nbsp;to View the Complete Input Details
          </p>
          <div>
            <LeadtimeModel data={viewAllData} openViewAllModal={openViewAllModal} loading={stateSelector?.ViewAllLineItemsDataSlice?.loading} handleCloseViewAllModal={handleCloseViewAllModal} />
          </div>
        </div>

      </div>
      {/* <div style={{ margin: "10px 0px", textAlign: "center" }}>
        <iframe title="LTResultsupdated" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=ed64bb79-a6dd-4c23-a33a-5a41930b849e&autoAuth=true&ctid=548d26ab-8caa-49e1-97c2-a1b1a06cc39c&navContentPaneEnabled=false" frameborder="0" allowFullScreen="true"></iframe>
      </div> */}
      {stateSelector?.PowerBIMaterialDetailsSlice?.loading ? <Loader /> :
        <div className="powerBi_cls">
          {embedConfig?.embedUrl && embedConfig?.accessToken &&
            <PowerBIEmbed
              embedConfig={embedConfig}
              getEmbeddedComponent={(embedObject) => {
                window.report = embedObject;
              }}
            />}
        </div>}

      <div className="analytic-results-tab result-margin" style={{ padding: '20px 10px' }}>
        <div style={{ margin: '0px 0px 10px 10px' }}>
          <span style={{ display: 'flex', alignItems: 'center' }}>Potential Impact of New Lead Time on Stock : <b style={{ marginLeft: 5 }}>{formData?.potentialImpact?.replace("-", "").trim() || "-"}</b> <span>
            {
              Number(formData?.potentialImpact?.replace("%", "").trim()) >= 0 ?
                <ArrowUpwardIcon style={{ color: 'red', fontSize: 20 }} /> : <ArrowDownwardIcon style={{ color: 'green', fontSize: 20 }} />
            }</span></span>
        </div>
        <div>

          <div className="recommondation_Section">
            <span id="recommondation_header">Recommendations:</span>
          </div>
          <div style={{ display: 'flex' }}>
            <div className="analytic-results left-recommendation">
              <div>
                <div className="result-item-rec">
                  <span>
                    % of orders with lower than recommended lead time
                  </span>
                  <p>: {confidenceLevel}</p>
                </div>
                <div className="result-item-rec">
                  <span>
                    Mode of Transport Considered for Recommendation
                  </span>
                  <p>: {combinedObject?.data?.transModeConsidered}</p>
                </div>
              </div>

            </div>
            <div className="right-recommendation">
              <div className="result-item" style={{ marginBottom: '10px', marginTop: 0 }}>
                <span style={{ marginBottom: 5 }}>
                  Recommended LT to be Updated in S/4
                </span>
                <ActionInput
                  // className="text-input"
                  name="finalLT"
                  props={{ height: "35px", maxWidth: "250px" }}
                  value={formData.LTData}
                  borderRadius="5px"
                  width="246px"
                  disabled={true}
                />
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className="analytic-results-buttons result-margin">
        <div className="analytic-results" style={{ width: "30%" }}>
          <ButtonComponent
            type="primary"
            maxWidth="80px"
            label="Back"
            onClick={() => navigate("/DPS-Planner-analytics", { state: combinedObject?.landingTitle })}
          />
        </div>
      </div>
    </div>
  );
};

export default DPSPlannerAnalyticsResultsDetails;
